import { linkifyHtml, linkifyText } from "@/lib/bibleLinkify";

export default function RichHtml({ html, className = "", testId, plainText = false }) {
  if (!html) return null;
  const processed = plainText ? linkifyText(html) : linkifyHtml(html);
  return (
    <div
      data-testid={testId}
      className={`prose prose-sm max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: processed }}
    />
  );
}
